import React from "react";
import { ArrowRight, Ruler, Hammer, Droplets } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Tile Installations",
  description: "Expert installation of porcelain, natural stone, and mosaic tiles for floors and walls with precision mitred edges.",
  icon: Ruler,
  link: "/ExpertServicesPage"
}, {
  title: "Bathroom Refurbishments",
  description: "Complete luxury bathroom renovations, managing everything from waterproofing and plumbing to the final high-end finish.",
  icon: Hammer,
  link: "/BathroomRenovationPage"
}, {
  title: "Wet Rooms",
  description: "Specialist installation of waterproof tanking systems, walk-in showers, and level-access wet rooms for modern living.",
  icon: Droplets,
  link: "/WetRoomsPage"
}];
export default function OurTilingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-tiling-expertise" ref={ref} className="py-16 transition-opacity duration-700 opacity-100 translate-y-0 !bg-[hsl(210,16%,93%)]">
      <div className="container ml-0 mr-auto px-4 md:px-6">
        <div className="text-left max-w-3xl ml-0 mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-black mb-6 tracking-tight">
            Our Tiling Expertise
          </h2>
          <p className="text-black text-lg md:text-xl leading-relaxed">
            Delivering precision craftsmanship and luxury finishes across London for over 11 years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Link to={service.link} className="block h-full group no-underline">
                <Card className="h-full py-0 border border-white/10 shadow-none rounded-sm bg-secondary/10 transition-all duration-300 group-hover:bg-secondary/20 group-hover:-translate-y-1 overflow-hidden relative">
                  <CardHeader className="pt-10">
                    <div className="mb-6 inline-flex items-center justify-start pl-3 w-12 h-12 rounded-none border border-primary/30 bg-primary/10 text-primary shadow-none transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                      <service.icon className="w-6 h-6 stroke-[1.25]" />
                    </div>
                    <CardTitle className="text-2xl font-serif font-bold text-black transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-black transition-colors duration-300">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pb-10">
                    <div className="flex items-center text-sm font-semibold text-black uppercase tracking-wider transition-colors duration-300 group-hover:text-black/80">
                      Learn More
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </CardFooter>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}